import React from 'react';
import { LuX } from 'react-icons/lu';
import './SidePanel.css';

// Painel deslizante pela lateral direita da tela — alternativa ao Modal
// centralizado pra fluxos de criar/editar mais longos (formulários com
// várias seções), reusável por qualquer feature.
const SidePanel = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="side-panel-overlay" onClick={onClose}>
      <div className="side-panel" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="side-panel__header">
          <h4 className="mb-0">{title}</h4>
          <button type="button" className="side-panel__close" onClick={onClose} aria-label="Fechar">
            <LuX size={20} />
          </button>
        </div>
        <div className="side-panel__body">{children}</div>
      </div>
    </div>
  );
};

export default SidePanel;
